<template>
	<AuthLayout>
		<template #eyebrow>Password recovery</template>
		<template #headline>Reset your<br/><span class="accent">password.</span></template>
		<template #lead>Enter your email and we'll send you a link to reset your password.</template>

		<!-- Success state -->
		<template v-if="showSuccessMessage">
			<div class="auth-card__head" style="text-align:center;">
				<div class="auth-success-icon">
					<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
				</div>
				<h1 class="auth-card__title">Check your email</h1>
				<p class="auth-card__subtitle">We've sent a password reset link to <b>{{ email }}</b></p>
			</div>
			<router-link :to="{ name: 'v2-login' }" class="auth-btn" style="text-decoration:none;">
				Back to Sign In
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
			</router-link>
		</template>

		<!-- Form -->
		<template v-else>
			<div class="auth-card__head">
				<p class="auth-card__step">Password recovery</p>
				<h1 class="auth-card__title">Reset Password</h1>
				<p class="auth-card__subtitle">Enter your email and we'll send you a reset link</p>
			</div>

			<form class="auth-form" @submit.prevent="resetPasswordRequest">
				<div class="auth-field">
					<label class="auth-field__label" for="reset-email">Email</label>
					<input
						id="reset-email"
						v-model="email"
						type="email"
						class="auth-input-light"
						placeholder="you@company.com"
					/>
				</div>

				<div v-if="error" class="auth-error">
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>
					{{ error }}
				</div>

				<button type="submit" class="auth-btn">
					Send Reset Link
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
				</button>
			</form>

			<div class="auth-card__foot">
				<p><router-link :to="{ name: 'v2-login' }">&larr; Back to Sign In</router-link></p>
			</div>
		</template>
	</AuthLayout>
</template>


<script>
import ResetPassword from '@/pages/reset-password.vue';
import AuthLayout from './auth-layout.vue';

export default {
	name: 'V2ResetPassword',

	extends: ResetPassword,

	components: {
		...ResetPassword.components,
		AuthLayout,
	},
};
</script>


<style lang="sass" scoped>
@import './auth-form-styles'

.auth-success-icon
	width: 64px
	height: 64px
	border-radius: 50%
	background: rgba($green, 0.15)
	color: $green
	display: flex
	align-items: center
	justify-content: center
	margin: 0 auto 16px
</style>
